const urlParams = Object.fromEntries(new URLSearchParams(window.location.search));
console.log('urlParams', JSON.parse(urlParams?.passwordRecover));
if (JSON.parse(urlParams?.passwordRecover)) {
  const recoverPasswordForm = document.querySelector('#recover_customer_password');
  const loginForm = document.querySelector('#customer_login');

  if(recoverPasswordForm) {
    recoverPasswordForm.style.display = 'block';
  }

  if(loginForm) {
    loginForm.style.display = 'none';
  }
}